import { Avatar } from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Tooltip } from "@mui/material";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { ReactComponent as ImportHover } from "../../../src/assets/USA_Images/ImportHover.svg";
import { ReactComponent as ImportIcon } from "../../../src/assets/USA_Images/ImportIcon.svg";
import "../../App.css";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import ProfileContext from "../../components/ProfileContext";
import CustomStyleStatus from "../../components/statusStyleFormat/statusStyleFormat";
import Toast from "../../components/ToastContainer/CustomToast";
import { listInvitations } from "../../slices/Invitations/InvitationsSlice";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import BlacklistVisitorForm from "../BlacklistVisitors/BlacklistVisitorForm";
import BlockVisitorIcon from "../Invitations/BlockVisitorIcon";
import CancelIcon from "../Invitations/CancelIcon";
import VisitorRegistrationViewPage from "../Registrations/VisitorRegistrationViewPage";
import BulkPreRegistration from "./BulkPreRegistration";
import CancelPreRegistration from "./CancelPreRegistration";
import CreatePreRegistration from "./CreatePreRegistration";
import PreRegistrationFilter from "./PreRegistrationFilter";

function PreRegistrationLists() {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [openCancelVisitor, setOpenCancelVisitor] = useState(false);
  const [visitorId, setVisitorId] = useState();
  const [visitorFirstName, setVisitorFirstName] = useState();
  const [visitorLastName, setVisitorLastName] = useState();
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { visitorStatus } = useContext(ProfileContext);

  const [
    openBulkPerRegistrationDialog,
    setOpenBulkPerRegistrationDialog,
  ] = useState(false);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [loading, setLoading] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [openBlacklistVisitor, setOpenBlacklistVisitor] = useState(false);
  const [blacklistId, setBlacklistId] = useState();

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const status = [
    "PENDING_ARRIVAL",
    "CHECKED_IN",
    "CHECKED_OUT",
    "CANCELLED",
    "REJECTED",
    "MISSED",
    "INITIATED_FOR_BLOCKED",
    "BLOCKED",
    "TIME_EXPIRED",
    "COMPLETED",
  ];

  const [filter, setFilter] = React.useState({
    status: [
      "PENDING_ARRIVAL",
      "CANCELLED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "COMPLETED",
    ],
    siteId: "",
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
    visitMode: ["PRE_REGISTRATION"],
    isPagable: true,
  });

  const defaultFilter = {
    status: [
      "PENDING_ARRIVAL",
      "MISSED",
      "CANCELLED",
      "CHECKED_IN",
      "CHECKED_OUT",
      "COMPLETED",
    ],
    visitorTypeId: "",
    siteId: "",
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
    visitMode: ["PRE_REGISTRATION"],
    isPagable: true,
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear, visitorStatus]);

  const openIfSiteExists = (openDialog) => {
    dispatch(getAllSites({ page: 1, rowsPerPage: 1, name: "" }))
      .unwrap()
      .then((data) => {
        if (
          data.code === "LMSI0000" &&
          !CommonUtil.isEmptyArray(data.data?.site)
        ) {
          openDialog();
        } else {
          Toast(
            t("Please create a site before creating a pre-registration"),
            "error",
          );
        }
      })
      .catch(() => {
        Toast(
          t("Please create a site before creating a pre-registration"),
          "error",
        );
      });
  };

  const handleOpen = () => {
    openIfSiteExists(() => {
      setOpen(true);
      setDiaLogBoxBlur(true);
    });
  };

  const resetFilter = () => {
    setLoading(true);
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const loadData = (filter, paging) => {
    dispatch(listInvitations(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setLoading(false);
          setTotalRecords(data.data.totalCount);
          setRows(data.data.visits);
          setPage(data.data.curPage);
          setPageSize(data.data.pageSize);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const handleFilter = (data) => {
    setLoading(true);
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      visitorTypeId: data.visitorTypeId,
      siteId: data.siteId,
      visitMode: data.visitMode,
      scheduledStartDate: CommonUtil.formatToUtc(data.scheduledStartDate),
      scheduledEndDate: CommonUtil.formatToUtc(data.scheduledEndDate),
      status: data.status,
    });
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(filter, { page: page, rowsPerPage: rowsPerPage });
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleCancelVisit = (params) => {
    setOpenCancelVisitor(!openCancelVisitor);
    setVisitorId(params.id);
    setVisitorFirstName(params.row.visitor.firstName);
    setVisitorLastName(params.row.visitor.lastName);
    setDiaLogBoxBlur(true);
  };
  const getStatuss = (params) => {
    if (
      params.row.status === "CHECKED_IN" ||
      params.row.status === "CHECKED_OUT" ||
      params.row.status === "CANCELLED" ||
      params.row.status === "MISSED" ||
      params.row.status === "COMPLETED"
    ) {
      return true;
    }
  };

  const handleStatus = (params) => {
    if (params.row.status === "PENDING_ARRIVAL") {
      return true;
    }
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 15) + "...";
    } else {
      return text;
    }
  };

  const renderCellScheduledStartDate = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.scheduledStartDate),
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : "",
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const handleBlacklistVisit = (params) => {
    setOpenBlacklistVisitor(!openBlacklistVisitor);
    setBlacklistId(params.row.id);
    setVisitorFirstName(params.row.visitor.firstName);
    setVisitorLastName(params.row.visitor.lastName);
    setDiaLogBoxBlur(true);
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row.visitor;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            onContextMenu={(e) => e.preventDefault()}
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };
  const columns = React.useMemo(
    () => [
      {
        field: "visitor.profile",
        headerName: "",
        sortable: false,
        width: 10,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },
      {
        field: "visitor.firstName",
        headerName: t("COMMON014"),
        flex: 1,
        minWidth: 120,
        valueGetter: (params) =>
          params.row.visitor.lastName !== null
            ? params.row.visitor.firstName + " " + params.row.visitor.lastName
            : params.row.visitor.firstName,
        renderCell: (params) => (
          <Tooltip
            title={` ${
              params.row.visitor.lastName !== null
                ? params.row.visitor.firstName +
                  " " +
                  params.row.visitor.lastName
                : params.row.visitor.firstName
            }`}
            placement="bottom-start"
          >
            <span>
              {handleTextOverflow(
                params.row.visitor.lastName !== null
                  ? params.row.visitor.firstName +
                      " " +
                      params.row.visitor.lastName
                  : params.row.visitor.firstName,
              )}
            </span>
          </Tooltip>
        ),
      },
      {
        field: "visitor.phone",
        headerName: t("COMMON063"),
        type: "singleSelect",
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.visitor.phone,
      },
      {
        field: "visitor.email",
        headerName: t("PERSON005"),
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.visitor.email,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.visitor.email}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row.visitor.email)}</span>
          </Tooltip>
        ),
      },
      {
        field: "hostName",
        headerName: t("commonsTextFeildHostValue"),
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.hostName,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.hostName}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.hostName)}</span>
          </Tooltip>
        ),
      },
      {
        field: "scheduledStartDate",
        headerName: t("INVITEDATELBL"),
        flex: 1,
        minWidth: 150,

        renderCell: renderCellScheduledStartDate(
          formatDate(companySettings.dateFormat),
        ),
      },
      {
        field: "status",
        headerName: t("COMMON001"),
        flex: 1,
        minWidth: 150,

        renderCell: (params) => {
          return <CustomStyleStatus row={params.row.status} icon={false} />;
        },
      },
      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 200,
        align: "left",
        headerAlign: "left",
        marginRight: "5px",
        getActions: (params) => [
          <div>
            <VisitorRegistrationViewPage rowData={params.row} />
          </div>,
          <Tooltip title={!getStatuss(params) ? t("COMMON008") : ""}>
            <Box
              sx={{
                opacity: getStatuss(params) ? 0.4 : 2, // Dim when disabled
                cursor: getStatuss(params) ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!getStatuss(params)) {
                  // only trigger if not disabled
                  handleCancelVisit(params);
                }
              }}
            >
              <CancelIcon />
            </Box>
          </Tooltip>,
          <Box
            sx={{
              opacity: handleStatus(params) ? 0.4 : 2, // Dim when disabled
              cursor: handleStatus(params) ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              if (!handleStatus(params)) {
                // only trigger if not disabled
                handleBlacklistVisit(params);
              }
            }}
          >
            <BlockVisitorIcon />
          </Box>,
        ],
      },
    ],
    [companySettings.dateFormat],
  );

  const handleImport = () => {
    openIfSiteExists(() => {
      setOpenBulkPerRegistrationDialog(true);
      setDiaLogBoxBlur(true);
    });
  };

  return (
    <>
      <HeaderToolbar
        title={t("PRE_REGISTRATION")}
        tooltipTitle={t("PRE_REGISTRATION")}
      />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          <PreRegistrationFilter
            rowsPerPage={rowsPerPage}
            selectedObject={filter.visitMode}
            applyFilter={(data) => handleFilter(data)}
            status={status}
          />
        </Box>
        {decoded_jwtToken.roleCode !== "FRONTDESK" && (
          <Tooltip title={t("VISACCLEVEL003")}>
            <Box
              item
              className={darkMode ? "importdark" : "import"}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={handleImport}
            >
              {isHovered ? (
                <ImportHover style={{ color: darkMode ? "#fff" : "#474a4e" }} />
              ) : (
                <ImportIcon style={{ color: darkMode ? "#fff" : "#474a4e" }} />
              )}
            </Box>
          </Tooltip>
        )}

        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>

        {decoded_jwtToken.roleCode !== "FRONTDESK" && (
          <Tooltip title={t("PRE_REGISTRATION")}>
            <Box item className={"addIcon"} onClick={handleOpen}>
              <CreateIcon />
            </Box>
          </Tooltip>
        )}

        {clear && (
          <Box item>
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          </Box>
        )}
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {open && (
        <CreatePreRegistration
          open={open}
          handleDialogClose={handleClose}
          loadData={() => {
            loadData(filter, paging);
          }}
          date={formatDate(companySettings.dateFormat)}
          perRegistrationIntervalTime={companySettings.walkInIntervalTime}
        />
      )}

      {openCancelVisitor && (
        <CancelPreRegistration
          open={openCancelVisitor}
          handleDialogClose={handleClose}
          loadData={() => {
            loadData(filter, paging);
          }}
          handleClose={(data) => {
            setOpenCancelVisitor(data);
            setDiaLogBoxBlur(false);
          }}
          CancelId={visitorId}
          CancelFirstName={visitorFirstName}
          cancelLastName={
            visitorLastName && visitorLastName != null && visitorLastName !== ""
              ? visitorLastName
              : ""
          }
          module={"Visitors"}
          subModule={"Invitations"}
        />
      )}

      {openBulkPerRegistrationDialog && (
        <BulkPreRegistration
          open={openBulkPerRegistrationDialog}
          handleClose={() => {
            setRows([]);
            setOpenBulkPerRegistrationDialog(false);
            setDiaLogBoxBlur(false);
            loadData(filter, paging);
          }}
          date={formatDate(companySettings.dateFormat)}
          perRegistrationIntervalTime={companySettings.walkInIntervalTime}
        />
      )}
      {openBlacklistVisitor && (
        <BlacklistVisitorForm
          open={openBlacklistVisitor}
          handleClose={(data) => {
            setOpenBlacklistVisitor(data);
            setDiaLogBoxBlur(false);
          }}
          disable={() => setDel(true)}
          BlacklistVisitorId={blacklistId}
          module={"Visitors"}
          subModule={"Pre Registration"}
          blockListName={`${visitorFirstName}${
            visitorLastName ? " " + visitorLastName : ""
          }`}
        />
      )}
    </>
  );
}

export default PreRegistrationLists;
